import type { QuoteStatus } from "@school-sales-ai/shared";

/**
 * How a quote request's status reads on screen — the trading company's words,
 * not the enum. `submitted` carries the accent: it is the state somebody has to
 * act on (a request that reached the team and nobody has taken).
 */
export const QUOTE_STATUS_META: Record<QuoteStatus, { label: string; className: string }> = {
  draft: { label: "En armado", className: "bg-ink-050 text-ink-500" },
  submitted: { label: "Nueva", className: "bg-lime/20 text-moss" },
  in_progress: { label: "Cotizando", className: "bg-amber-50 text-amber-700" },
  sent: { label: "Enviada", className: "bg-sky-50 text-sky-700" },
  won: { label: "Ganada", className: "bg-moss/10 text-moss" },
  lost: { label: "Perdida", className: "bg-red-50 text-red-700" },
  abandoned: { label: "Abandonada", className: "bg-ink-050 text-ink-500" },
};

/** The statuses the list offers as a filter — a draft is the agent's, not the team's. */
export const FILTERABLE_QUOTE_STATUSES: readonly QuoteStatus[] = [
  "submitted",
  "in_progress",
  "sent",
  "won",
  "lost",
];

/** The label on the button that moves a request INTO each status. */
export const QUOTE_ACTION_LABEL: Partial<Record<QuoteStatus, string>> = {
  in_progress: "Tomar y cotizar",
  sent: "Marcar como enviada",
  won: "Marcar como ganada",
  lost: "Marcar como perdida",
};
